import PropTypes from "prop-types";
import React from "react";
import {
  Typography,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  IconButton
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicator from "@mui/icons-material/DragIndicator";
import ResourceTypeIcon from "../../../components/Icons/ResourceTypeIcon";
import EditableLabel from "../../../components/EditableLabel/EditableLabel";

const useStyles = makeStyles(theme => ({
  listItemContainer: {
    "&:hover $iconButton": {
      opacity: 1
    }
  },
  listItemGutters: {
    paddingLeft: theme.spacing(1.75)
  },
  iconButton: {
    opacity: 0,
    transition: "opacity 300ms"
  },
  dragButton: {
    cursor: "move",
    display: "flex"
  },
  dragButtonIcon: {
    color: theme.palette.action.active,
    minWidth: 48
  }
}));

const EditAndDeleteButtons = ({ onEdit, onDelete }) => {
  const classes = useStyles();
  return (
    <div>
      <IconButton className={classes.iconButton} onClick={onEdit} size="large">
        <EditIcon color="primary" />
      </IconButton>
      <IconButton
        className={classes.iconButton}
        onClick={onDelete}
        size="large"
      >
        <DeleteIcon color="primary" />
      </IconButton>
    </div>
  );
};

const ResourceListItem = ({
  item,
  onClick,
  onEditItem,
  onDeleteItem,
  dragHandleProps
}) => {
  const classes = useStyles();
  const [editMode, setEditMode] = React.useState(false);
  const onEditComplete = value => {
    setEditMode(false);
    return onEditItem(value);
  };
  return (
    <ListItem
      button
      alignItems="center"
      classes={{
        gutters: classes.listItemGutters,
        container: classes.listItemContainer
      }}
      onClick={onClick}
    >
      <div
        className={`${classes.iconButton} ${classes.dragButton}`}
        {...dragHandleProps}
      >
        <DragIndicator color="primary" className={classes.dragButtonIcon} />
      </div>
      <ListItemIcon className={classes.icon}>
        <ResourceTypeIcon type={item.itemType} />
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography component="div" variant="body1" color="textSecondary">
            <EditableLabel
              initialValue={item.name}
              onEditComplete={onEditComplete}
              initialEditability={editMode}
            />
          </Typography>
        }
      />
      <ListItemSecondaryAction>
        <EditAndDeleteButtons
          onEdit={ev => {
            ev.preventDefault();
            ev.stopPropagation();
            setEditMode(true);
          }}
          onDelete={onDeleteItem}
        />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default ResourceListItem;

ResourceListItem.propTypes = {
  onDeleteItem: PropTypes.func,
  onEditItem: PropTypes.func,
  onClick: PropTypes.func,
  item: PropTypes.shape({
    /**
     * The name of the resource
     */
    name: PropTypes.string,

    /**
     * The type of the resource
     */
    type: PropTypes.string
  }),
  dragHandleProps: PropTypes.any
};
